import React from 'react';
import img1 from '../../../../images/successful-medical-team (1).jpg';
import img2 from '../../../../images/treatment.jpg';
import img3 from '../../../../images/new-img.jpg';
import './Banner.css';
const Banner = () => {

    return (
        <div>
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img height="780px" src={img1} className="d-block w-100" alt="..."/>
            <div className="carousel-caption d-none d-md-block">
            <h5 className="text-dark">Qualified Staff With</h5>
              <h1 className="text-dark">Expertise in Services</h1>
              <h1 className="text-dark">We Offer</h1>
             <button className="btn btn-danger">Read More</button>
            </div>
          </div>
          <div className="carousel-item">
            <img height="780px" src={img2} className="d-block w-100" alt="..."/>
            <div className="carousel-caption d-none d-md-block">
              <h5 className="text-white">Qualified Staff With</h5>
              <h1 className="text-white">Expertise in Services</h1>
              <h1 className="text-white">We Offer</h1>
             <button className="btn btn-danger">Read More</button>
            </div>
          </div>
          <div className="carousel-item">
            <img height="780px" src={img3} className="d-block w-100" alt="..."/>
            <div className="carousel-caption d-none d-md-block">
            <h5 className="text-white">Qualified Staff With</h5>
              <h1 className="text-white">Expertise in Services</h1>
              <h1 className="text-white">We Offer</h1>
             <button className="btn btn-danger">Read More</button>
            </div>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <div className="d-grid gap-2 container my-4 ">
      <button className="btn btn-danger" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">Make an Appointment Now!!!</button>

<div className="offcanvas offcanvas-top" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
  <div className="offcanvas-header">
    <h5 id="offcanvasTopLabel"> </h5>
    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div className="offcanvas-body">
  <h2>Please Fill up the form:</h2> 
  <form>
  <div className="container">
  <div className="row">
    <div className="col">
      <input type="text" className="form-control" placeholder="Name"/>
    </div>
    <div className="col">
      <input type="text" className="form-control" placeholder="Phone Number"/>
    </div>
    <div className="col">
      <input type="text" className="form-control" placeholder="Email Address"/>
    </div>
  </div>
  <br />
  <div className="row">
  <div className="col">
      <input type="text" className="form-control" placeholder="Appointment Date"/>
    </div>
    <div className="col">
      <input type="text" className="form-control" placeholder="Doctor's Name"/>
    </div>
  </div>
  <br/>
  <div>
    <button className="btn btn-danger">Submit</button>
  </div>
  </div>
</form>

  </div>
</div>
      </div>
     </div>
    );
};

export default Banner;